import { render, staticRenderFns } from "./FilterSidebar.vue?vue&type=template&id=ae7f5bc4&scoped=true"
import script from "./FilterSidebar.vue?vue&type=script&lang=js"
export * from "./FilterSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7f5bc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7f5bc4')) {
      api.createRecord('ae7f5bc4', component.options)
    } else {
      api.reload('ae7f5bc4', component.options)
    }
    module.hot.accept("./FilterSidebar.vue?vue&type=template&id=ae7f5bc4&scoped=true", function () {
      api.rerender('ae7f5bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebar.vue"
export default component.exports